"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
var media_service_1 = __importDefault(require("./media.service"));
var helpers_1 = require("../shared/helpers");
var DataService = (function () {
    function DataService() {
        this.cache = {
            allComicsFetched: false,
            comics: {},
        };
    }
    DataService.prototype.getFirestore = function () {
        return app_1.default.firestore();
    };
    DataService.prototype.logCache = function () {
        console.log('<< THE CACHE >>');
        console.log(this.cache);
    };
    DataService.prototype.getPrevAndNextEpisodes = function (episode, comicEpisodes) {
        var index = comicEpisodes.findIndex(function (listEpisode) { return listEpisode.id === episode.id; });
        if (index === -1)
            return [];
        return [comicEpisodes[index - 1], comicEpisodes[index + 1]];
    };
    DataService.prototype.cachedComicsToArray = function () {
        return Object.values(this.cache.comics);
    };
    DataService.prototype.getComics = function () {
        return __awaiter(this, void 0, void 0, function () {
            var comicsSnap, comicsWithoutMedia, mediaForComics, allComics;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.cache.allComicsFetched)
                            return [2, this.cachedComicsToArray()];
                        return [4, this.getFirestore()
                                .collection('comics')
                                .where('status', '==', 'P')
                                .get()];
                    case 1:
                        comicsSnap = _a.sent();
                        if (comicsSnap.empty)
                            return [2, []];
                        comicsWithoutMedia = comicsSnap.docs.map(function (comicDoc) {
                            var comic = __assign(__assign({}, comicDoc.data()), { id: comicDoc.id });
                            return comic;
                        });
                        return [4, Promise.all(comicsWithoutMedia.map(function (comic) { return media_service_1.default.getMediaForComic(comic.id); }))];
                    case 2:
                        mediaForComics = _a.sent();
                        allComics = comicsWithoutMedia.reduce(function (acc, comic, index) {
                            var _a;
                            return (__assign(__assign({}, acc), (_a = {}, _a[comic.id] = __assign(__assign({}, comic), { media: mediaForComics[index] }), _a)));
                        }, {});
                        this.cache.comics = allComics;
                        this.cache.allComicsFetched = true;
                        return [2, this.cachedComicsToArray()];
                }
            });
        });
    };
    DataService.prototype.getComicBySlug = function (comicSlug, includeEpisodes) {
        if (includeEpisodes === void 0) { includeEpisodes = false; }
        return __awaiter(this, void 0, void 0, function () {
            var foundComic, comicDocRef, comicsSnap, comicDoc, _a, episodesSnap, episodeList, episodeListWithNextEpisodes, episodeListWithNextEpisodesAndThumbails;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        foundComic = this.cachedComicsToArray().find(function (comic) { return comic.slug === comicSlug; });
                        if (foundComic && ((includeEpisodes && foundComic.episodes) ||
                            (!includeEpisodes)))
                            return [2, foundComic];
                        if (!foundComic) return [3, 1];
                        comicDocRef = this.getFirestore().collection('comics').doc(foundComic.id);
                        return [3, 4];
                    case 1: return [4, this.getFirestore()
                            .collection('comics')
                            .where('slug', '==', comicSlug)
                            .where('status', '!=', 'H')
                            .get()];
                    case 2:
                        comicsSnap = _c.sent();
                        if (comicsSnap.empty)
                            return [2, undefined];
                        comicDoc = comicsSnap.docs[0];
                        _a = [__assign({}, comicDoc.data())];
                        _b = { id: comicDoc.id };
                        return [4, media_service_1.default.getMediaForComic(comicDoc.id)];
                    case 3:
                        foundComic = __assign.apply(void 0, _a.concat([(_b.media = _c.sent(), _b)]));
                        this.cache.comics[foundComic.id] = foundComic;
                        if (!includeEpisodes) {
                            return [2, foundComic];
                        }
                        comicDocRef = comicDoc.ref;
                        _c.label = 4;
                    case 4: return [4, comicDocRef
                            .collection('episodes')
                            .where('status', '==', 'P')
                            .orderBy('sequenceCode')
                            .get()];
                    case 5:
                        episodesSnap = _c.sent();
                        episodeList = episodesSnap.docs.map(function (episodeDoc) {
                            return (__assign(__assign({}, episodeDoc.data()), { id: episodeDoc.id }));
                        });
                        episodeListWithNextEpisodes = episodeList.map(function (episode, inx) {
                            var isLastEpisode = inx === episodeList.length - 1;
                            return __assign(__assign({}, episode), { nextEpisodeSlug: isLastEpisode ? null : episodeList[inx + 1].slug, isLastEpisode: isLastEpisode });
                        });
                        return [4, media_service_1.default.getEpisodeListWithThumbnails(foundComic.id, episodeListWithNextEpisodes)];
                    case 6:
                        episodeListWithNextEpisodesAndThumbails = _c.sent();
                        foundComic.episodes = episodeListWithNextEpisodesAndThumbails;
                        return [2, foundComic];
                }
            });
        });
    };
    DataService.prototype.getCachedEpisodeBySlug = function (comicSlug, episodeSlug, lang, forceMediaRefetch) {
        var _a;
        if (forceMediaRefetch === void 0) { forceMediaRefetch = false; }
        return __awaiter(this, void 0, void 0, function () {
            var foundComic, foundEpisode, _b, _c;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        foundComic = this.cachedComicsToArray().find(function (comic) { return comic.slug === comicSlug; });
                        if (!foundComic || !foundComic.episodes)
                            return [2, undefined];
                        foundEpisode = foundComic.episodes.find(function (episode) { return episode.slug === episodeSlug; });
                        if (!foundEpisode)
                            return [2, undefined];
                        if (((_a = foundEpisode.media) === null || _a === void 0 ? void 0 : _a.pages) && !forceMediaRefetch)
                            return [2, foundEpisode];
                        _b = foundEpisode;
                        _c = [__assign({}, foundEpisode.media)];
                        _d = {};
                        return [4, media_service_1.default.getPagesForEpisode(foundComic.id, foundEpisode, lang)];
                    case 1:
                        _b.media = __assign.apply(void 0, _c.concat([(_d.pages = _e.sent(), _d)]));
                        return [2, foundEpisode];
                }
            });
        });
    };
    DataService.prototype.subscribeToComments = function (comicId, episodeId, callback) {
        return this.getFirestore()
            .collection('comics')
            .doc(comicId)
            .collection('episodes')
            .doc(episodeId)
            .collection('comments')
            .orderBy('pubDate', 'desc')
            .onSnapshot(function (commentsSnap) {
            var commentsArray = commentsSnap.docs.map(function (comment) {
                return (__assign(__assign({}, comment.data()), { id: comment.id }));
            });
            callback(commentsArray);
        });
    };
    DataService.prototype.addComment = function (comicId, episodeId, comment) {
        return __awaiter(this, void 0, void 0, function () {
            var isoDate, commentId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isoDate = new Date().toISOString();
                        commentId = isoDate.split('.')[0] + '-' + (0, helpers_1.getRandomNumber)(3);
                        return [4, this.getFirestore()
                                .collection('comics')
                                .doc(comicId)
                                .collection('episodes')
                                .doc(episodeId)
                                .collection('comments')
                                .doc(commentId)
                                .set(__assign(__assign({}, comment), { pubDate: new Date().toISOString() }))];
                    case 1:
                        _a.sent();
                        return [2, commentId];
                }
            });
        });
    };
    return DataService;
}());
exports.default = new DataService();
